import(/* webpackMode: "eager" */ "/vercel/path0/client/src/app/support/page.tsx");
